var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.7031C20.8737 18.7031 20.7475 18.6788 20.6286 18.6301L2.90987 11.4113C2.53912 11.2607 2.29688 10.9006 2.29688 10.5C2.29688 10.0994 2.53912 9.73928 2.90987 9.58867L20.6286 2.36992C20.8664 2.27253 21.1336 2.27253 21.3714 2.36992L39.0901 9.58867C39.4609 9.73928 39.7031 10.0994 39.7031 10.5C39.7031 10.9006 39.4609 11.2607 39.0901 11.4113L21.3714 18.6301C21.2525 18.6788 21.1263 18.7031 21 18.7031ZM5.89023 10.5L21 16.6556L36.1098 10.5L21 4.34444L5.89023 10.5Z",
    fill: "url(#paint0_linear_84_6149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 18.7423C8.64373 18.7423 8.20312 18.3014 8.20312 17.7579V12.9084C8.20312 12.365 8.64373 11.9241 9.1875 11.9241C9.73127 11.9241 10.1719 12.365 10.1719 12.9084V17.7579C10.1719 18.3014 9.73127 18.7423 9.1875 18.7423Z",
    fill: "url(#paint1_linear_84_6149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 29.2032C20.3115 29.2032 19.6145 29.1666 18.9278 29.0943C18.3873 29.0366 17.9954 28.5521 18.0524 28.0118C18.1094 27.471 18.5936 27.0845 19.1348 27.1358C19.7526 27.2011 20.3804 27.2344 21.0001 27.2344C24.8379 27.2344 29.3676 26.0457 31.8282 24.4262V12.9084C31.8282 12.365 32.2688 11.9241 32.8126 11.9241C33.3563 11.9241 33.7969 12.365 33.7969 12.9084V24.9376C33.7969 25.2471 33.6511 25.5394 33.4031 25.7252C30.716 27.7407 25.4999 29.2032 21.0001 29.2032Z",
    fill: "url(#paint2_linear_84_6149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8748 32.4844C28.331 32.4844 27.8904 32.0434 27.8904 31.5V15.0937L20.6211 12.0644C20.1192 11.8548 19.8821 11.2786 20.091 10.7769C20.3003 10.2744 20.8758 10.0386 21.3785 10.2469L29.2535 13.5287C29.6201 13.6819 29.8592 14.0401 29.8592 14.4375V31.5C29.8592 32.0434 29.4186 32.4844 28.8748 32.4844Z",
    fill: "url(#paint3_linear_84_6149)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 39.7031H26.25C25.9734 39.7031 25.7097 39.5865 25.5232 39.3827C25.3367 39.1783 25.2445 38.9053 25.2697 38.6297L25.7479 33.3714C25.8959 31.7435 27.2401 30.5156 28.875 30.5156C30.5098 30.5156 31.8541 31.7435 32.0021 33.3714L32.4802 38.6297C32.5055 38.9053 32.4132 39.1783 32.2267 39.3827C32.0402 39.5865 31.7765 39.7031 31.5 39.7031ZM27.3279 37.7344H30.422L30.0416 33.5495C29.9863 32.9426 29.4848 32.4844 28.875 32.4844C28.2652 32.4844 27.7637 32.9426 27.7083 33.5495L27.3279 37.7344Z",
    fill: "url(#paint4_linear_84_6149)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80753 16.7485C5.66625 16.7485 2.29688 20.1176 2.29688 24.2589C2.29688 28.4003 5.66625 31.7699 9.80753 31.7699C13.9488 31.7699 17.3182 28.4002 17.3182 24.2589C17.3182 20.1177 13.9489 16.7485 9.80753 16.7485ZM13.1747 22.9368L9.7438 26.8743C9.56019 27.0851 9.29552 27.2075 9.01609 27.212H9.00165C8.72734 27.212 8.46523 27.0973 8.27873 26.8954L6.45964 24.9267C6.0905 24.5274 6.11517 23.9051 6.51444 23.536C6.91373 23.1669 7.53664 23.1919 7.90545 23.5911L8.98019 24.7537L11.6904 21.6435C12.0477 21.2333 12.669 21.1904 13.0792 21.548C13.489 21.905 13.5319 22.5266 13.1747 22.9368Z",
    fill: "url(#paint5_linear_84_6149)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80751 33.738C8.30903 33.738 6.83896 33.3709 5.51562 32.6978V38.7182C5.51562 39.0726 5.70628 39.4 6.01486 39.5744C6.32344 39.7506 6.70187 39.7448 7.00598 39.5629L9.80751 37.8844L12.6091 39.5629C12.7648 39.6558 12.9398 39.7026 13.1151 39.7026C13.2823 39.7026 13.4496 39.6602 13.6002 39.5744C13.9087 39.4 14.0994 39.0726 14.0994 38.7182V32.7039C12.7746 33.38 11.3131 33.738 9.80751 33.738Z",
    fill: "url(#paint6_linear_84_6149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_84_6149",
    x1: 20,
    y1: -15.5965,
    x2: 25.1995,
    y2: 14.7687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_84_6149",
    x1: 9.13487,
    y1: 4.4878,
    x2: 15.3449,
    y2: 9.08076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_84_6149",
    x1: 25.5009,
    y1: -6.92129,
    x2: 37.4146,
    y2: 20.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_84_6149",
    x1: 24.674,
    y1: -14.1646,
    x2: 45.7706,
    y2: 9.67522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_84_6149",
    x1: 28.682,
    y1: 20.4953,
    x2: 35.657,
    y2: 34.5326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_84_6149",
    x1: 9.40595,
    y1: 0.365582,
    x2: 19.1007,
    y2: 25.1978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_84_6149",
    x1: 9.57806,
    y1: 25.0575,
    x2: 13.4383,
    y2: 37.1733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/Student.a4745f7e9ad02e57f4e2bc89043e3769.svg";
export { ForwardRef as ReactComponent };